// extracted by mini-css-extract-plugin
export default {"Flash":"HiddenUnicode-module__Flash--rePIQ","Button":"HiddenUnicode-module__Button--vIANN","Octicon":"HiddenUnicode-module__Octicon--fj19R"};